<template>
  <v-app xs12 sm12 md12 lg12 xl12>
    <BadPage v-if="incorrectUrl" />
    <StatusPopup v-if="status != null" :status="this.status" :orderId="this.orderId" />
    <router-view v-if="!incorrectUrl" />
  </v-app>
</template>

<script>
import BadPage from "@/components/BadPage";
import StatusPopup from "@/components/StatusPopup";
import AOS from 'aos';
import 'aos/dist/aos.css';
import storeData from './mixins/storeData';

export default {
  components: { BadPage, StatusPopup},
  mixins: [storeData],
  data() {
    return {
      incorrectUrl: false,
      status: null,
      orderId: null
    };
  },
  beforeMount() {
    let tenantId = document.getElementById('app').dataset.tenant;
    let urlParams = new URLSearchParams(window.location.search);

    if(tenantId === undefined){
      this.isPlugin = false;
      tenantId = urlParams.get("tenantId");
    }else{
      this.isPlugin = true;
    }

    let status = urlParams.get("status");
    let orderId = urlParams.get("orderId");

    if (tenantId === null || isNaN(tenantId) || tenantId.length === 0) {
      this.incorrectUrl = true;
    } else {
      if (status != null && status.length > 0) {
        if (status === "success" || status === "failure") {
          this.status = status;
          if (orderId != null) {
            this.orderId = orderId;
          }
        } else {
          this.incorrectUrl = true;
        }
      }
    }
  }
};
AOS.init({offset: 60});
</script>

<style>
#app{
  background-color: white;
}

body{
  font-size: 1em !important;
  font-weight: 400 !important;
}

hr{
  margin: 0 !important;
}

input[type="text"],
input[type="email"],
input[type="url"],
input[type="password"],
input[type="search"],
input[type="number"],
input[type="tel"],
input[type="range"],
input[type="date"],
input[type="month"],
input[type="week"],
input[type="time"],
input[type="datetime"],
input[type="datetime-local"],
input[type="color"],
textarea {
  border: none;
}
</style>